import React, { useState } from "react";

const program = {
  torsdag: [
    {
      title: "09:00 – Seneste oppmøte på Gardermoen 🕘",
      description:
        "Sjekk enten inn selv ellers så er det oppmøte ved meeting point i avgangshallen Hvor medlemsbånd deles ut.",
      image: "/img/oslo.png",
    },
    {
      title: "11:00 – Avreise med Norwegian 🛫",
    },
    {
      title: "12:25 – Ankomst Gdansk 🏙️",
    },
    {
      title: "13:15 – Transfer til Sheraton Hotel, Sopot 🚌🏖️",
      description:
        "En kort busstur til Sopot, hvor vi sjekker inn på det flotte Sheraton-hotellet, rett ved stranden.",
    },
    {
      title: "14:00 – Lunsj 🥗🍗",
    },
    {
      title: "16:00 – Innsjekk på hotellet 🏨🧳",
      description:
        "Ankomst til hotellet, innsjekk og tid til å slappe av før kvelden.",
        image: "/img/sheraton.png",
    },
    {
      title: " Egentid",
    },
    {
      title: "19:45 – Avreise til middag 🚶‍♂️‍➡️🚶‍♀️‍➡️",
    },
    {
      title: "20:00 – Middag Bulaj 💃",
      description: "Vi spaserer sammen til middag på Bulaj.",
    },
  ],
  fredag: [
    {
      title: "07:00 – Frokost (alle) 🥖🥪",
    },
    {
      title: "08:00 – Faglig samling for medlemmer/leverandører (på hotellet) 🖥️",
      description:
        "Samling i seminarlokalet på hotellet for faglig påfyll og nettverksbygging.",
    },
    {
      title: "Lunsj underveis 🥗🥞 ",
    },
    {
      title: "09:30 – Ledsagertur 🚤🚶‍♀️‍➡️🚶‍♂️‍➡️",
      description:
        "Ledsagerprogram med båttur, kokekurs og sightseeing",
    },
    {
      title: "Ettermiddag – Egentid",
    },
    {
      title: "19:30 – Spasertur til middag 🚶‍♂️‍➡️🚶‍♀️‍➡️",
    },
    {
      title: "20:00 – Middag på restaurant White Marlin",
      description: "Stilfull restaurant og moderne rett ved stranden.",
    },
  ],
  lørdag: [
    {
      title: "09:00 – Frokost 🥪🥖",
    },
    {
      title: "10:00 – Oppmøte i resepsjonen for forhåndsvalgte aktiviteter 🛎️",
    },
    {
      title: "1. Sykkeltur til gamlebyen i Gdansk 15 km 3 timer",
      description:
        "Vi begynner sykkelturen ved hotellet. Første 6 km sykler vi langs stranda, og da tar vi en ølpause (kaffe eller brus er også mulig). Like før vi ankommer gamlebyen, stopper vi på det historiske verftet hvor Lech Walesa jobbet, og så sykler vi litt rundt i gamlebyen. Sykler leverer vi i selve gamlebyen. Det er helt flat hele veien til gamlebyen og vi sykler på sykkelveier. Det er virkelig en lett og avslappende sykkeltur. Det er felles lunsj etter tur.1 og 2, deretter båttur tilbake til Sopot.",
      image: "/img/gdansk-lordag.png",
    },
    {
      title: "2. Busstur og sightseeing i Gdansk • 4 timer",
      description:
        "Vi begynner bussturen ved hotellet og første stopp er Oliwa katedral med dens mektige pipeorgel. Oliwa er en bydel som grenser med Sopot, ca. 15 min å kjøre fra hotellet. Vi tar en tur i kirken og hører på 20 min orgelkonsert. Derfra kjører vi til gamlebyen i Gdansk (ca. 20 min) hvor vi tar en gåtur i de gamle gatene og langs elva. Det er felles lunsj etter tur.1 og 2, deretter båttur tilbake til Sopot.",
        image: "/img/gdansk-buss.png",
    },
    {
      title: "3. Egentid i Sopot/Gdansk",
      description:
        "Denne dagen kan du gjøre hva du vil, om du vil være på stranden ved hotellet, rusle rundt i Sopot eller reise inn til Gdansk på eget initiativ.",
        image: "/img/sopot-beach.png",
    },
    {
      title: "Ettermiddag – Egentid",
    },
    {
      title: "19:30 – Apertif før gallamiddag 🍸",
      description:
        "Det serves en aperitiff før middagen.",
    },
    {
      title: "20:00 – Galla middag på hotellet 🍽️",
      description:
        "En eksklusiv kulinarisk opplevelse i en elegant setting. Vi oppfordrer til pent antrekk.",
    },
  ],
  søndag: [
    
    {
      title: "09:00 – Frokost og utsjekk senest kl 12:00",
    },
    {
      title: "Formiddag – Egentid",
    },
    {
      title: "12:45 – Gruppe 1 transfer til flyplassen 🚌",
    },
    {
      title: "15:25 – Gruppe 1 Avreise med Norwegian 🛫",
    },
    {
      title: "16:55 – Ankomst Oslo 🛬",
    },
    {
      title: "19:45 – Gruppe 2 transfer til flyplassen 🚌",
    },
    {
      title: "22:35 – Gruppe 2 Avreise med Norwegian 🛫",
    },
    {
      title: "00:05 – Ankomst Oslo 🛬",
    },
  ],
};

const days = Object.keys(program);

export default function Program() {
  const [selectedDay, setSelectedDay] = useState("torsdag");
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (idx) => {
    setExpandedIndex(expandedIndex === idx ? null : idx);
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h2 style={{ marginBottom: "1rem" }}>Program</h2>

        <div style={{ display: "flex", gap: "10px", marginBottom: "1.5rem", flexWrap: "wrap" }}>
            {days.map((day) => (
                <button
                key={day}
                onClick={() => {
                    setSelectedDay(day);
                    setExpandedIndex(null);
                }}
                style={{
                    padding: "0.5rem 1rem",
                    borderRadius: "8px",
                    border: selectedDay === day ? "2px solid #06111e" : "1px solid #ccc",
                    backgroundColor: selectedDay === day ? "#cedc00" : "#fff",
                    cursor: "pointer",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    color: "#06111e",
                    WebkitTapHighlightColor: "transparent",
                    WebkitTextFillColor: "unset",
                }}
                >
                {day}
                </button>
            ))}
            </div>

      <ul style={{ listStyle: "none", padding: 0 }}>
        {program[selectedDay].map((item, idx) => (
          <li key={idx} style={{ marginBottom: "1rem" }}>
            <div
                onClick={() => item.description && toggleExpand(idx)}
                style={{
                    cursor: item.description ? "pointer" : "default",
                    fontWeight: "500",
                    color: "#06111e",
                    backgroundColor: "#f9f9f9",
                    padding: "0.75rem 1rem",
                    borderRadius: "6px",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                    WebkitTapHighlightColor: "transparent",
                    WebkitTextFillColor: "unset",
                }}
                >
              {item.title}
              {item.description && (
                <span style={{ marginLeft: "0.5rem", color: "#666", fontSize: "0.9rem" }}>
                  {expandedIndex === idx ? "▲" : "▼"}
                </span>
              )}
            </div>

            {expandedIndex === idx && (
              <div style={{ marginTop: "0.5rem", paddingLeft: "1rem" }}>
                <p>{item.description}</p>
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.title}
                    style={{
                      maxWidth: "100%",
                      borderRadius: "8px",
                      marginTop: "0.5rem",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                  />
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
